/* eslint-disable */

export enum MediaQuery {
	Small = 0,
	Phone = 1,
	Tablet = 2,
	Large = 3,
	Desktop = 4,
	Huge = 5,
	Ultra = 6,
	
}
